<div [ngClass]="{'fx-justify-end': isNumericalColumn ,'fx-justify-space-between': !isNumericalColumn}"
     class="ag-cell-editor fx-layout-row fx-justify-center fx-gap-5">
  <div>
    {{ params.valueFormatted }}
  </div>
  <div>
    <i aria-hidden="true" class="mdi mdi-pencil tooltip-icon"></i>
  </div>
</div>